import React from 'react';
import Table, { CellProps } from 'rsuite/Table';
import IconButton from 'rsuite/IconButton';
import { trpcSwr } from '../../../../api/trpc';
import { RbacObject } from '../../../../export-types/cleaned-types';
import { Rbac } from '../../../common/Rbac';
import { ModalsService } from '../../../../services/modals.service';
import { FeatureFlagEditModal } from './feature-flag-edit-modal';
import { User } from '../../../common/user-multi-select';

type FlagItem = {
  id: number;
  name: string;
  enabledForAll: boolean;
  users: User[];
};

export const FeatureFlagsTab = () => {
  const { data, isLoading, mutate } = trpcSwr.featureFlag.list.useSWR();

  const ActionCell = ({ rowData, ...props }: CellProps<FlagItem>) => {
    if (!rowData) return null;
    return (
      <Table.Cell
        {...props}
        className="link-group no-padding-cell pt-2"
        align="right"
      >
        <Rbac object={RbacObject.FeatureFlag} action={'write:admin'}>
          <IconButton
            appearance="subtle"
            icon={<i className="bi bi-pencil" />}
            onClick={() =>
              ModalsService.createModal(FeatureFlagEditModal, {
                flag: rowData,
                mutate,
              })
            }
          />
        </Rbac>
      </Table.Cell>
    );
  };

  const EnabledForAllCell = ({ rowData, ...props }: CellProps<FlagItem>) => {
    if (!rowData) return null;
    return (
      <Table.Cell {...props}>{rowData.enabledForAll ? 'Да' : 'Нет'}</Table.Cell>
    );
  };

  const UsersCountCell = ({ rowData, ...props }: CellProps<FlagItem>) => {
    if (!rowData) return null;
    return (
      <Table.Cell {...props}>
        {rowData.enabledForAll ? '—' : rowData.users.length}
      </Table.Cell>
    );
  };

  return (
    <Table data={data ?? []} headerHeight={57} autoHeight loading={isLoading}>
      <Table.Column flexGrow={2}>
        <Table.HeaderCell>Название</Table.HeaderCell>
        <Table.Cell dataKey="name" />
      </Table.Column>
      <Table.Column flexGrow={1}>
        <Table.HeaderCell>Для всех</Table.HeaderCell>
        <EnabledForAllCell />
      </Table.Column>
      <Table.Column flexGrow={1}>
        <Table.HeaderCell>Пользователи</Table.HeaderCell>
        <UsersCountCell />
      </Table.Column>
      <Table.Column width={60}>
        <Table.HeaderCell> </Table.HeaderCell>
        <ActionCell />
      </Table.Column>
    </Table>
  );
};
